<template>
    <div class="faq">
        <div class="container">
            <div class="row">
                <div class="col-12" id="accordion">
                    <div class="card" v-for="(faq, index) in faqs">
                        <div
                             class="card-header"
                             id="faqHeading-1">
                            <div class="mb-0">
                                <h5 class="faq-title"
                                    data-toggle="collapse"
                                    v-bind:data-target="'#faq' + index"
                                    data-aria-expanded="true"
                                    v-bind:data-aria-controls="'#faq' + index">
                                    <span class="badge"></span>
                                    <strong>{{ faq.question }}</strong>
                                </h5>
                            </div>
                        </div>
                        <div v-bind:id="'faq' + index"
                             class="collapse"
                             data-parent="#accordion">
                            <div class="card-body">
                                <p v-html="faq.answer"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            faqs: {
                type: Array
            }
        }
    };
</script>
<style scoped>
    .faq {
        width: 100%;
        height: auto;
        float: left;
    }

        .faq .card {
            border: none;
            background: none;
            border-bottom: 1px solid #ddd;
            border-radius: 0;
        }

            .faq .card .card-header {
                padding: 0px;
                border: none;
                background: none;
                -webkit-transition: all 0.3s ease 0s;
                -moz-transition: all 0.3s ease 0s;
                -o-transition: all 0.3s ease 0s;
                transition: all 0.3s ease 0s;
            }

                .faq .card .card-header:hover {
                    background: #f8f8f8;
                    padding-right: 10px;
                }

                .faq .card .card-header .faq-title {
                    width: 100%;
                    padding: 0px;
                    font-weight: 400;
                    font-size: 13px;
                    color: #666;
                    text-decoration: none !important;
                    -webkit-transition: all 0.3s ease 0s;
                    -moz-transition: all 0.3s ease 0s;
                    -o-transition: all 0.3s ease 0s;
                    transition: all 0.3s ease 0s;
                    cursor: pointer;
                    padding-top: 13px;
                }

                    .faq .card .card-header .faq-title .badge {
                        display: inline-block;
                        width: 15px;
                        height: 15px;
                        border-radius: 100px;
                        background: #d00918;
                        margin-left: 20px;
                        position: relative;
                        top: 3px;
                    }

            .faq .card .card-body {
                padding: 30px;
                padding-left: 35px;
                padding-bottom: 16px;
            }

                .faq .card .card-body p {
                    margin-bottom: 14px;
                }

    @media (max-width: 991px) {
        .faq {
            margin-bottom: 30px;
        }

            .faq .card .card-header .faq-title {
                line-height: 26px;
                margin-top: 10px;
            }
    }
</style>
